import { useEffect, useState } from "react";

/**
 * Minimum height used for initial scroll inset and before the first layout pass.
 * Keeps the mnemonics view's scroll padding from collapsing to zero on first paint.
 */
const FOOTER_LAYOUT_FALLBACK_HEIGHT = 0;

// Module-level pub/sub so footer height can update the mnemonics view's scroll insets.
type HeightListener = (height: number) => void;
const _contentHeightListeners = new Set<HeightListener>();
let _lastContentHeight = FOOTER_LAYOUT_FALLBACK_HEIGHT;

function subscribeContentHeight(listener: HeightListener) {
  _contentHeightListeners.add(listener);
  listener(_lastContentHeight);
  return () => {
    _contentHeightListeners.delete(listener);
  };
}

export function publishDrillFooterContainerContentHeight(height: number) {
  _lastContentHeight = height;
  for (const listener of _contentHeightListeners) {
    listener(height);
  }
}

/** Returns the current footer content height and re-renders when it changes. */
export function useDrillFooterContainerContentHeight() {
  const [contentHeight, setContentHeight] = useState(_lastContentHeight);
  useEffect(() => subscribeContentHeight(setContentHeight), []);
  return contentHeight;
}
